export default __webpack_public_path__ + "static/media/585_7.a88507b8.jpg";